export enum ServerZoneEnum {
    EU = 'EU',
    US = 'US',
}
